import { render, staticRenderFns } from "./HistoryProcess.vue?vue&type=template&id=19db57e8&scoped=true"
import script from "./HistoryProcess.vue?vue&type=script&lang=js"
export * from "./HistoryProcess.vue?vue&type=script&lang=js"
import style0 from "./HistoryProcess.scss?vue&type=style&index=0&id=19db57e8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db57e8",
  null
  
)

export default component.exports